import MetricCategoryItem, { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'

export const resolveValueFromMetric = (name: MetricCategoryItemStrings) => {
  switch (name) {
    case MetricCategoryItem.FIVE_STAR:
      return 5
    case MetricCategoryItem.FOUR_STAR:
      return 4
    case MetricCategoryItem.THREE_STAR:
      return 3
    case MetricCategoryItem.TWO_STAR:
      return 2
    case MetricCategoryItem.ONE_STAR:
      return 1
    case MetricCategoryItem.NO_RESPONSE_STAR:
    default:
      return -1
  }
}

export default resolveValueFromMetric
